import { WalletType } from "../../../shared";
import { z } from "zod";

/**
 * Schema for the payload sent to `POST /v1/hub/trade/internal-transfer`.
 * Transfers funds between wallet types within the same exchange account.
 */
export const HubInternalTransferBodySchema = z.object({
  accountId: z.number().int().positive(),
  tokenSymbol: z.string().min(1),
  amount: z.number().positive(),
  fromWalletType: z.nativeEnum(WalletType),
  toWalletType: z.nativeEnum(WalletType),
  /** Required for isolated margin transfers */
  pairSymbolFrom: z.string().optional(),
  /** Required for isolated margin transfers */
  pairSymbolTo: z.string().optional(),
});

export type HubInternalTransferBody = z.infer<typeof HubInternalTransferBodySchema>;

/**
 * Schema for the query params sent to `GET /v1/hub/trade/transfer-routes`.
 * Returns the available transfer routes for a given exchange account.
 */
export const HubTransferRoutesQuerySchema = z.object({
  accountId: z.coerce.number().int().positive(),
});

export type HubTransferRoutesQuery = z.infer<typeof HubTransferRoutesQuerySchema>;

/**
 * Response type for transfer routes endpoint.
 */
export type HubTransferRoutesResponse = Record<WalletType, WalletType[]>;

/**
 * Response type for internal transfer endpoint.
 */
export type HubInternalTransferResponse = {
  id: string;
};
